<template>
  <li class="w-full mb-2 ml-0 inline-block" :class="{ 'cursor-pointer': !session.isDisabled && session.redirect }" @click="handleClick">
    <div
      class="flex flex-wrap overflow-hidden shadow w-full text-xs py-2 px-1"
      :style="{ backgroundColor: session.activity_color || '#1999d4' }"
      :class="{
        'h-[110px]': isDaily ,
        'h-[200px]': !isDaily && byMonths,
        'h-[110px]': !isDaily && !byMonths && session.grouped,
        'h-[200px]': !isDaily && !byMonths && !session.grouped,
        'shadow opacity-50': session.isDisabled
      }"
    >
      <div v-if="session.activity_color" class="w-full relative overflow-hidden">
        <div class="absolute h-full w-full" :style="{ backgroundColor: session.activity_color }"></div>
      </div>
      <div class="flex relative flex-wrap text-white z-40 mx-2 h-full">

        <div v-if="byMonths" class="w-full text-left pl-4 pt-4 text-xs">
          Du {{ session.startDate }} au {{ session.endDate }}
        </div>
        <div v-if="byMonths" class="w-full text-left pl-4 pb-4">
          De {{ session.startTime }} à {{ session.endTime }}
        </div>

        <div v-else class="w-full text-left pl-2 pt-2 pb-2">
          {{ session.startTime }} - {{ session.endTime }}
        </div>

        <div v-if="!isDaily && isCustomPlanner" class="text-2xl text-left px-4">
          <h4 class="my-0 text-xs">{{ session.type }}</h4>
        </div>

        <div v-if="!isDaily && !session.grouped && !byMonths">
          <div class="text-2xl text-left px-2">
            <h4 class="my-0 text-base">{{ session.type }}</h4>
          </div>
        </div>

        <div v-if="session.hasStock && !byMonths && session.showStock" class="w-full flex justify-start items-end mt-2 pb-2 ml-2">
          {{ session.stockLabel }}
        </div>

        <div v-if="session.hasStock && !byMonths && session.redirect" class="w-full flex justify-end items-end text-xs">
          <a class=" text-[10px] px-1 py-1" :class="{ 'bg-black bg-opacity-50 hover:bg-opacity-80': !session.isDisabled }">
            <i class="icon hidden md:inline icon-calendar mr-2 text-[10px]" />
            RÉSERVER
          </a>
        </div>

        <div v-if="session.hasStock && !byMonths && !session.redirect && session.reservationLimitMessage" class="w-full flex justify-end items-end">
          <a
            class="p-2 text-xs"
            :class="{ 'bg-black bg-opacity-50 hover:bg-opacity-80': !session.isDisabled }"
            @click="openContactCenterModal(session.reservationLimitMessage)"
          >
            Contacter le centre
          </a>
        </div>

        <div v-if="session.hasStock && byMonths" class="w-full flex flex-wrap justify-between">
          <div v-if="session.showStock" class="w-1/2 flex ml-4 pb-2">
            {{ session.stockLabel }}
          </div>

          <div v-if="session.redirect" class="flex justify-end mr-4 w-full">
            <a class="flex items-center text-[10px] px-1 py-1" :class="{ 'bg-black bg-opacity-50 hover:bg-opacity-80': !session.isDisabled }">
              <i class="icon hidden md:inline icon-calendar mr-4"></i>
              RÉSERVER
            </a>
          </div>
          <div v-else-if="session.hoursReserveLimitation" class="w-full flex justify-end items-end">
            <a
              class="p-2 text-xs"
              :class="{ 'bg-black bg-opacity-50 hover:bg-opacity-80': !session.isDisabled }"
              @click="openContactCenterModal(session.reservationLimitMessage)"
            >
              Contacter le centre
            </a>
          </div>
        </div>

        <div v-if="!session.hasStock && session.showStock" class="w-full pb-4 flex justify-start items-end mt-4 ml-4 text-xs">
          Complet
        </div>

      </div>
    </div>
  </li>
</template>

<script setup>
import { defineProps, inject, ref } from 'vue';

const props = defineProps({
  session: {
    type: Object,
    default: () => ({})
  }
});

const reddirectToTDA = inject('reddirectToTDA');

const isDaily = inject('isDaily', ref(false));

const byMonths = inject('byMonths', ref(false));
const openContactCenter = inject('openContactCenter');

const isCustomPlanner = inject('isCustomPlanner', ref(false));

const handleClick = () => {
  if (props.session.isDisabled || !props.session.redirect) {
    return;
  };

  reddirectToTDA(props.session);
};

const openContactCenterModal = (message) => {
  openContactCenter(message)
};

</script>
